<template>
  <div v-show="!activation" id="collectionWrapper" :class="{ 'closed': !collectionPanelIsVisible, 'is-hidden': isEmpty }">
    <div id="toggle" class="columns">
      <div class="column">
        <a class="has-text-grey" @click="toggle">
          <i class="fas" :class="collectionPanelIsVisible ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
        </a>
      </div>
    </div>

    <div v-if="!collectionPanelIsVisible" id="mobileToggle" @click="toggle"></div>

    <div class="columns">
      <div class="column">
        <div id="collectionContent">
          <h2 class="subtitle is-4">
            Programma
            <span v-if="programme">{{ programme.name }} <sup><i class="fas fa-pen is-size-7" @click="toggleSave"></i></sup></span>
          </h2>

          <h2 class="subtitle is-6">Kennis en documenten</h2>

          <div v-for="(knowledge, index) in programme.collection.knowledge" class="card">
            <div class="card-content">

              <button type="button" class="delete is-pulled-right" @click="removeKnowledgeFromCollection(index)"></button>

              <div class="media">
                <div v-if="hasImage(knowledge.knowledge)" class="media-left">
                  <figure class="image is-48x48">
                    <img :src="knowledge.knowledge.attachments[0].file" alt="Placeholder image">
                  </figure>
                </div>

                <div class="media-content">
                  <p class="title is-4">{{ knowledge.knowledge.title }}</p>

                  <p class="subtitle is-6">
                    {{ knowledge.knowledge.item.name }}
                    <span class="is-pulled-right is-size-7">
                      <a v-if="showMore === knowledge.knowledge.id" @click="toggleShowMore(null)">Sluiten</a>
                      <a v-else @click="toggleShowMore(knowledge.knowledge.id)">Lees meer</a>
                    </span>
                  </p>
                </div>
              </div>

              <template v-if="showMore === knowledge.knowledge.id">
                <div
                  v-html="knowledge.knowledge.description"
                  class="content">
                </div>
                <p @click="toggleShowMore(null)">Sluiten</p>
              </template>

              <span class="icon" @click="toggleComment(knowledge.knowledge.id)">
                <i :class="knowledge.comment ? 'fas fa-comment-alt' : 'far fa-comment-alt'"></i>
              </span>

              <textarea
                name="comment"
                class="textarea"
                :class="{ 'is-hidden': showComment !== knowledge.knowledge.id }"
                v-model="knowledge.comment"></textarea>

              </div>
            </div>

            <h2 class="subtitle is-6">Producten</h2>

            <div v-for="(product, index) in programme.collection.products" class="card">
              <div class="card-content">

                <button type="button" class="delete is-pulled-right" @click="removeProductFromCollection(index)"></button>

                <div class="media">
                  <div v-if="product.product.images.length > 0" class="media-left">
                    <figure class="image is-48x48">
                      <img :src="product.product.images[0].file" alt="Placeholder image">
                    </figure>
                  </div>

                  <div class="media-content">
                    <p class="title is-4">{{ product.product.name }}</p>

                    <p class="subtitle is-6">
                      {{ product.product.item.name }}
                      <span class="is-pulled-right is-size-7">
                        <a v-if="showMore === product.product.id" @click="toggleShowMore(null)">Sluiten</a>
                        <a v-else @click="toggleShowMore(product.product.id)">Lees meer</a>
                      </span>
                    </p>
                  </div>
                </div>

                <template v-if="showMore === product.product.id">
                  <div
                    v-html="product.product.description"
                    class="content">
                  </div>
                  <p @click="toggleShowMore(null)">Sluiten</p>
                </template>

                <span class="icon" @click="toggleComment(product.product.id)">
                  <i :class="product.comment ? 'fas fa-comment-alt' : 'far fa-comment-alt'"></i>
                </span>

                <textarea
                  name="comment"
                  class="textarea"
                  :class="{ 'is-hidden': showComment !== product.product.id }"
                  v-model="product.comment"></textarea>

                </div>
              </div>

              <hr/>

              <template v-if="showSave">
                <div class="notification">
                  <button class="delete" @click="toggleSave"></button>

                  <div class="field">
                    <label class="label" for="name">Naam van het programma</label>
                    <div class="control">
                      <input type="text" class="input" v-model="programme.name">
                    </div>
                  </div>

                </div>
              </template>

              <template v-if="isLoggedIn">
                <button
                  type="button"
                  class="button"
                  :class="saved ? 'is-success': 'is-link'"
                  @click="save">
                  Programma {{ saved ? 'opgeslagen' : 'opslaan' }}
                </button>

                <button
                  v-if="programme.id"
                  type="button"
                  class="button"
                  @click="download">
                  Programma downloaden
                </button>
              </template>

              <template v-else>
                <div class="notification is-info">
                  <strong>Dit programma bewaren en/of downloaden?</strong> Maak <router-link :to="{ name: 'signup' }"></router-link> een account.
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { bus } from '../main'

  export default {
    data () {
      return {
        showSave: false,
        loading: false,
        saved: null,
        showComment: false,
        showMore: null
      }
    },
    computed: {
      collectionPanelIsVisible () {
        return this.$store.getters.getCollectionPanelVisibility
      },
      programme () {
        return this.$store.getters.programme
      },
      isLoggedIn () {
        return this.$store.getters.isLoggedIn
      },
      activation () {
        return this.$route.path.includes('activeren')
      },
      isEmpty() {
        return this.programme.collection.knowledge.length === 0 && this.programme.collection.products.length === 0
      },
    },
    mounted () {
      let self = this

      bus.$on('toggleProductInCollection', function (payload) {
        const itemId = payload.itemId
        const productId = payload.productId

        let e = self.$store.getters.productInCollection(itemId, productId)

        if (e === -1) {
          self.$store.dispatch('addProductToCollection', {
            itemId: itemId,
            productId: productId
          })
        } else {
          self.$store.commit('removeProductFromCollection', e)
        }
      })

      bus.$on('toggleKnowledgeInCollection', function (payload) {
        const itemId = payload.itemId
        const knowledgeId = payload.knowledgeId

        let e = self.$store.getters.knowledgeInCollection(itemId, knowledgeId)

        if (e === -1) {
          self.$store.dispatch('addKnowledgeToCollection', {
            itemId: itemId,
            knowledgeId: knowledgeId
          })
        } else {
          self.$store.commit('removeKnowledgeFromCollection', e)
        }
      })
    },
    methods: {
      toggleShowMore (id) {
        this.showMore = id
      },
      toggleComment (id) {
        if (this.showComment === id) {
          this.showComment = false
        } else {
          this.showComment = id
        }
      },
      toggle () {
        this.$store.commit('toggleCollection')
      },
      open () {
        if (!this.collectionPanelIsVisible()) {
          this.toggle()
        }
      },
      productInCollection (itemId, productId) {
        return this.collection.findIndex(e => e.itemId === itemId && e.productId === productId)
      },
      removeProductFromCollection (e) {
        this.$store.commit('removeProductFromCollection', e)
      },
      removeKnowledgeFromCollection (e) {
        this.$store.commit('removeKnowledgeFromCollection', e)
      },
      toggleSave () {
        this.showSave = !this.showSave
      },
      hasImage (item) {
        return item.attachments.length > 0
      },
      save () {
        if (!this.programme.name) {
          this.toggleSave()
          return
        }

        let self = this
        this.loading = true
        this.saved = null

        if (this.programme.id) {
          axios.put(
            `programmes/${this.programme.id}`, this.programme
          ).then(
            (res) => {
              this.loading = false
              this.saved = true
              this.showSave = false
              setTimeout(function () {
                self.saved = null
              }, 2500)
            }
          ).catch(
            (err) => {
              this.loading = false
              this.errors = err.response.data.errors
            }
          )
        } else {
          axios.post(
            'programmes', this.programme
          ).then(
            (res) => {
              this.loading = false
              this.saved = true
              this.showSave = false
              setTimeout(function () {
                self.saved = null
              }, 2500)
              this.$store.commit('addProgramm', res.data)
            }
          ).catch(
            (err) => {
              this.loading = false
              this.errors = err.response.data.errors
            }
          )
        }
      },
      download () {
        this.$store.dispatch('downloadProgramme', this.programme)
      }
    }
  }
</script>

<style scoped>
  .notification {
    margin-top: 15px;
  }

  #collectionWrapper {
    position: absolute;
    right: 0;
    top: 0;
    width: 500px;
    height: 100vh;
    margin-right: 0;
    padding: 15px;
    border-width: 0 0 0 1px;
    border-style: solid;
    border-color: hsl(0, 0%, 86%);
    background-color: #fff;
    z-index: 40;
    box-shadow: -1px -1px 5px #ddd;
    transition: margin-right 0.4s ease-out;
  }

  #collectionWrapper.closed {
    margin-right: -470px;
  }

  @media screen and (max-width: 600px) {
    #collectionWrapper {
      width: 100%;
    }

    #collectionWrapper.closed {
      margin-right: -98%;
      padding: 0;
    }

    #collectionWrapper.closed #toggle {
      display: none;
    }

    #mobileToggle {
      height: 100%;
    }
  }

  #collectionWrapper.closed #collectionContent {
    display: none;
  }

  .subtitle.is-6 {
    margin-top: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Collection.vue